module.exports = __webpack_public_path__ + "static/the-four-pillars-of-investing-6c2df0af8c161d0ac37c013edb3f27eb.jpg";